export const TYPING_SPEED_MS = 300
export const ERASE_SPEED_MS = 200
export const HOLD_MS = 2200
export const BETWEEN_MS = 600
export const CURSOR_BLINK_MS = 500

export const PLACEHOLDER_PREFIX = 'e.g. '
export const STATE_CODES = ['MH', 'DL', 'KA', 'TN', 'GJ', 'RJ', 'UP', 'WB', 'AP', 'TS', 'KL', 'MP', 'HR', 'PB', 'UK']
